module.exports = __webpack_public_path__ + "img/up.5b9cbd5a.svg";